import React, { Component } from 'react'
import withRoot from '../../withRoot'
import { Login as Layout } from '../../layouts'
import { Box, Form } from '../index'
import { t as i18n } from 'ttag'

class Login extends Component {
  render() {
    return (
      <Layout>
        <Box
          headerTitle={i18n`Log in to your account`}
          subHeader={i18n`Welcome to the LSEG Due Diligence Portal, LSEG's new due diligence report ordering and delivery platform.`}
          footer={
            <span>
              A note to our existing EDDO and EDD customers: the LSEG Due Diligence Portal is
              replacing our existing ordering platforms, and all orders should
              be placed through the LSEG Due Diligence Portal going forward. For any questions,
              please reach out to your dedicated Sales representative or raise a{' '}
              <a href='https://myaccount.lseg.com/en/helpandsupport'>
                MyAccount
              </a>{' '}
              ticket to our support team by choosing the query you have, then
              selecting 'LSEG Due Diligence Reports'. Once submitted, one
              of the team will be in touch.
            </span>
          }
          {...this.props}
        >
          <Form {...this.props} />
        </Box>
      </Layout>
    )
  }
}

export default withRoot(Login)
